<template>
  <div class="presupuestos">
    <v-container
      class="primary lighten-2 pa-0"
      fluid
      id="principal-container"
    >






      <v-toolbar color="primary" dark dense>
        <v-btn
          absolute
          dark
          fab
          bottom
          right
          z-index="2"
          color="accent"
          @click="add()"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>

        <v-row>
          <v-col>
            <div>
              <h2>
                Presupuestos por
                <v-select
                  :items="lapsos"
                  class="d-inline-block ml-1 title"
                  style="width: 100px"
                  hide-details
                  single-line
                  color="green--text"
                  item-text="label"
                  return-object
                  v-model="lapsoSelected"
                  label="Lapso"
                ></v-select>
              </h2>
            </div>
          </v-col>
          <v-col xs="6" sm="4" md="2">
            <v-select
              :items="temporadas"
              hide-details
              single-line
              color="green--text"
              item-text="periodo"
              return-object
              v-model="temporadaSelected"
              label="temporada"
            ></v-select>
          </v-col>
          <v-col cols="1"> </v-col>
        </v-row>
      </v-toolbar>















      <section class="chart-list pa-3">
        <section class="chart-container">
          <vue-anychart :options="CombineOptions" ref="combineChart"></vue-anychart>
        </section>
      </section>

















      <v-expand-transition>
        <div v-show="presupuestosGuardados.length > 0">
          <h2 class="white--text pl-3 mt-3">
            <v-icon color="white" class="mr-2">save</v-icon> Guardados
          </h2>
          <v-slide-y-transition group tag="v-row" dense class="pa-3">
            <template v-for="presupuesto in presupuestosGuardados">
              <v-col xs="6" sm="4" md="3" :key="presupuesto.id">
                <v-card class="pa-2 text-center" elevation="2" @click="load(presupuesto)" :ripple="{ class: 'accent--text' }">
                  <v-card-title class="px-2 py-0 mb-1">
                    <v-row no-gutters class="align-center">
                      <v-col cols="grow">
                        <selector-labor
                          :items="sublabores"
                          text-empty="labores"
                          title="Seleccionar Labores"
                          :groups="sublaboresGroups"
                        >
                          <template slot-scope="{ on }">
                            <v-btn
                              x-small
                              color="green lighten-3"
                              block
                              tile
                              class="flex-grow-1 flex-shrink-0 mr-1"
                              depressed
                              :ripple="false"
                            >
                              {{ presupuesto.laborGroup.name }}
                            </v-btn>
                          </template>
                        </selector-labor>
                      </v-col>
                      <v-col cols="grow">
                        <selector-labor
                          :items="sectores"
                          text-empty="sectores"
                          title="Seleccionar Sectores"
                          :groups="sectoresGroups"
                        >
                          <template slot-scope="{ on }">
                            <v-btn
                              x-small
                              color="green lighten-2"
                              block
                              tile
                              class="flex-grow-1 flex-shrink-0"
                              depressed
                              :ripple="false"
                            >
                              {{ presupuesto.sectorGroup.name }}
                            </v-btn>
                          </template>
                        </selector-labor>
                      </v-col>
                      <v-col cols="auto">
                        <v-btn flat icon color="primary" x-small @click="attach(presupuesto)">
                          <v-icon>close</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>

                    <!--
                <v-tooltip bottom color="rgba(0, 0, 0, 0.8)">
                  <template v-slot:activator="{ on }">
                    <v-btn color="green lighten-4" class="flex-grow-1 flex-shrink-0 mr-1" depressed v-on="on">
                      {{presupuesto.labor.name}}
                    </v-btn>
                  </template>
                  <div><span><span class="font-weight-bold">Labor:</span>Poda y Amarras</span></div>
                  <div><span><span class="font-weight-bold">SubLabor:</span>Poda</span></div>
                </v-tooltip>
                <v-tooltip bottom color="rgba(0, 0, 0, 0.8)">
                  <template v-slot:activator="{ on }">
                <v-btn color="indigo lighten-4" class="flex-grow-1 flex-shrink-0" depressed v-on="on">
                  {{presupuesto.sectorGroup.name}}
                </v-btn>
                  </template>
                  <div><span><span class="font-weight-bold">Sector 1:</span> 1 ha</span></div>
                  <div><span><span class="font-weight-bold">Sector 2:</span> 0.9 ha</span></div>
                  <div><span><span class="font-weight-bold">Sector 3:</span> 1.4 ha</span></div>
                </v-tooltip>
              -->
                  </v-card-title>
                  <v-card-text class="pa-0 subtitle-1 ">
                    <span class="porcent error--text font-weight-bold">
                      ( {{ presupuesto.porcentaje }}% )
                    </span>
                    <span>
                      {{ presupuesto.avance }} de {{ presupuesto.total }}
                      {{ presupuesto.unidad }}
                    </span>
                  </v-card-text>
                  <div class="">
                    <span class="overline"> id: {{ presupuesto.id }} </span>
                  </div>
                </v-card>
              </v-col>
            </template>
          </v-slide-y-transition>
          <v-divider dark class="ma-3"></v-divider>
        </div>
      </v-expand-transition>




















      <v-slide-y-transition tag="v-row" class="pa-3" group>
        <template v-for="presupuesto in presupuestos">
          <v-col cols="12" :key="presupuesto.id">
            <v-card class="presupuesto" elevation="4">
              <v-row no-gutters :align="'stretch'">
                <v-col cols="3">
                  <v-card
                    class="text-center d-flex flex-column"
                    fill-height
                    flat
                  >
                    <v-card-title class="px-2 py-0 mb-1">
                      <v-row no-gutters>
                        <v-col cols="grow">
                          <selector-labor
                            :items="sublabores"
                            text-empty="labores"
                            title="Seleccionar Labores"
                            :groups="sublaboresGroups"
                          >
                            <template slot-scope="{ on }">
                              <v-btn
                                x-small
                                color="green lighten-3"
                                block
                                tile
                                class="flex-grow-1 flex-shrink-0 mr-1"
                                depressed
                                v-on="on"
                              >
                                {{ presupuesto.laborGroup.name }}
                              </v-btn>
                            </template>
                          </selector-labor>
                        </v-col>
                        <v-col cols="grow">
                          <selector-labor
                            :items="sectores"
                            text-empty="sectores"
                            title="Seleccionar Sectores"
                            :groups="sectoresGroups"
                          >
                            <template slot-scope="{ on }">
                              <v-btn
                                x-small
                                color="green lighten-2"
                                block
                                tile
                                class="flex-grow-1 flex-shrink-0"
                                depressed
                                v-on="on"
                              >
                                {{ presupuesto.sectorGroup.name }}
                              </v-btn>
                            </template>
                          </selector-labor>
                        </v-col>
                      </v-row>
                    </v-card-title>
                    <v-card-text class="pa-0">
                      <v-row no-gutters>
                        <v-col cols="6">
                          <v-card tile outlined>
                            <v-list
                              flat
                              subheader
                              dense
                              class="text-right orange--text intercalate"
                            >
                              <v-list-item class="pa-0">
                                <v-toolbar
                                  color="primary lighten-3"
                                  dense
                                  flat
                                >
                                  ha: 10
                                </v-toolbar>
                              </v-list-item>
                              <v-list-item>
                                <v-list-item-content class="grey--text">
                                  <v-list-item-title>
                                    Presupuesto
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                              <v-list-item>
                                <v-list-item-content class="grey--text">
                                  <v-list-item-title>
                                    Real
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                              <v-list-item>
                                <v-list-item-content class="grey--text">
                                  <v-list-item-title>
                                    Reprogramado
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list>
                          </v-card>
                        </v-col>
                        <v-col cols="6">
                          <v-card tile outlined>
                            <v-list
                              dense
                              flat
                              subheader
                              class="text-right orange--text intercalate"
                            >
                              <v-list-item class="pa-0">
                                <v-toolbar
                                  color="primary lighten-3"
                                  dense
                                  flat
                                >
                                  Rendimiento
                                </v-toolbar>
                              </v-list-item>
                              <v-list-item>
                                <v-list-item-content class="grey--text">
                                  <v-list-item-title>
                                    1500 pl/j
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                              <v-list-item>
                                <v-list-item-content class="grey--text">
                                  <v-list-item-title>
                                    1500 pl/j
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                              <v-list-item>
                                <v-list-item-content class="grey--text">
                                  <v-list-item-title>
                                    <v-text-field
                                      label="Reprog"
                                      single-line
                                      hide-details
                                      suffix="pl/j"
                                      class="x-small right"
                                      outlined
                                    ></v-text-field>
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>

                <v-col cols="9">
                  <v-card flat class="d-flex flex-column">
                    <v-card-title class="px-2 py-0 mb-1">

                      <div class="body-2">
                        <span class="porcent error--text font-weight-bold">
                          ( {{ presupuesto.porcentaje }}% )
                        </span>
                        <span>
                          {{ presupuesto.avance }} de {{ presupuesto.total }}
                          {{ presupuesto.unidad }}
                        </span>
                      </div>


                      <v-spacer></v-spacer>
                      <span class="overline"> id: {{ presupuesto.id }} </span>
                      <v-tooltip bottom color="rgba(0, 0, 0, 0.8)">
                        <template v-slot:activator="{ on }">
                          <v-btn
                            :depressed="isAttached(presupuesto)"
                            icon
                            x-small
                            :color="
                              isAttached(presupuesto) ? 'accent' : 'primary'
                            "
                            v-on="on"
                            @click="attach(presupuesto)"
                          >
                            <v-icon>save</v-icon>
                          </v-btn>
                        </template>
                        guardar
                      </v-tooltip>
                      <v-tooltip bottom color="rgba(0, 0, 0, 0.8)">
                        <template v-slot:activator="{ on }">
                          <v-btn
                            text
                            icon
                            x-small
                            color="primary"
                            v-on="on"
                            @click="duplicate(presupuesto)"
                          >
                            <v-icon>filter_none</v-icon>
                          </v-btn>
                        </template>
                        Duplicar
                      </v-tooltip>
                      <v-tooltip bottom color="rgba(0, 0, 0, 0.8)">
                        <template v-slot:activator="{ on }">
                          <v-btn
                            text
                            icon
                            x-small
                            color="primary"
                            v-on="on"
                            @click="quit(presupuesto)"
                          >
                            <v-icon>close</v-icon>
                          </v-btn>
                        </template>
                        Quitar
                      </v-tooltip>
                    </v-card-title>
                    <v-card-text class="pa-0">
                      <v-row class="flex-row" no-gutters>
                        <v-col cols="11" grow>
                          <div class="card-text-scroll mb-1">
                            <div class="scroll-container">
                              <div v-for="tiempo in lapsosComputed">
                                <v-card tile outlined>
                                  <v-list flat subheader dense class="intercalate">
                                    <v-list-item class="pa-0">
                                      <v-toolbar
                                        color="primary lighten-4"
                                        dense
                                        flat
                                      >
                                        {{ tiempo.name }}
                                      </v-toolbar>
                                    </v-list-item>
                                    <v-list-item>
                                      <v-list-item-content>
                                        <v-list-item-title>
                                          1.85
                                        </v-list-item-title>
                                      </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                      <v-list-item-content>
                                        <v-list-item-title>
                                          4
                                        </v-list-item-title>
                                      </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                      <v-list-item-content>
                                        <v-list-item-title>
                                          <v-text-field
                                            single-line
                                            hide-details
                                            suffix="jor"
                                            class="x-small right"
                                            dense
                                            outlined
                                          ></v-text-field>
                                        </v-list-item-title>
                                      </v-list-item-content>
                                    </v-list-item>
                                  </v-list>
                                </v-card>
                              </div>
                            </div>
                          </div>
                        </v-col>
                        <v-col cols="1">
                          <div class="total-card mb-1">
                            <v-card tile outlined>
                              <v-list flat subheader class="text-left intercalate" dense>
                                <v-list-item class="pa-0">
                                  <v-toolbar
                                    color="primary lighten-2"
                                    dense
                                    flat
                                  >
                                    total
                                  </v-toolbar>
                                </v-list-item>
                                <v-list-item>
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      6.15
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      6.9
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      5.7
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                              </v-list>
                            </v-card>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </template>
      </v-slide-y-transition>






    </v-container>
  </div>
</template>
<script>
// TODO: calculos de presupuestos

import selectorLabor from "@/components/selectorLabor";
import _ from "lodash";

  import VueAnychart from '@/components/VueAnychart'
  import * as data from '@/data/data'
  import Anychart from 'anychart'

export default {
  name: "Presupuestos",
  components: {
    VueAnychart,
    selectorLabor
  },
  computed:{
    lapsosComputed(){
      if(this.lapsoSelected.label == "Mes"){
        return this.meses;
      }
      if(this.lapsoSelected.label == "Semana"){
        return this.semanas;
      }
      return [];
    }
  },
  data: () => ({



        Anychart       : Anychart,
        CombineOptions : data.ganttData,
        data           : data.data,





    lapsos: [{ label: "Mes" }, { label: "Semana" }],
    temporadas: [
      { periodo : "2017-2018" },
      { periodo : "2018-2019" },
      { periodo : "2019-2020" },
      { periodo : "2020-2021" },
      { periodo : "2021-2022" }
    ],
    meses: [
      { id : 1, name: "Mayo" },
      { id : 2, name: "Junio" },
      { id : 3, name: "Julio" },
      { id : 4, name: "Agosto" },
      { id : 5, name: "Septiembre" },
      { id : 6, name: "Octubre" },
      { id : 7, name: "Noviembre" },
      { id : 8, name: "Diciembre" },
      { id : 9, name: "Enero" },
      { id : 10, name: "Febrero" },
      { id : 11, name: "Marzo" },
      { id : 12, name: "Abril" }
    ],
    semanas: [
      { id : 1, name: "Semana 1" },
      { id : 2, name: "Semana 2" },
      { id : 3, name: "Semana 3" },
      { id : 4, name: "Semana 4" },
      { id : 5, name: "Semana 5" },
      { id : 6, name: "Semana 6" },
      { id : 7, name: "Semana 7" },
      { id : 8, name: "Semana 8" },
      { id : 9, name: "Semana 9" }
    ],
    lapsoSelected         : null,
    temporadaSelected     : null,
    presupuestos          : [],
    presupuestosGuardados : [],
    sublaboresGroups      : [{ label: "grupo de labores", path: "labor.name" }],
    sublabores            : [
      {
        id: 1,
        name: "poda",
        labor: {
          id: 1,
          name: "poda y amarra"
        }
      },
      {
        id: 2,
        name: "amarra",
        labor: {
          id: 1,
          name: "poda y amarra"
        }
      },
      {
        id: 3,
        name: "poda",
        labor: {
          id: 1,
          name: "poda y amarra 2"
        }
      },
      {
        id: 4,
        name: "amarra",
        labor: {
          id: 1,
          name: "poda y amarra 2"
        }
      },
      {
        id: 5,
        name: "poda"
      },
      {
        id: 6,
        name: "amarra"
      },
      {
        id: 7,
        name: "poda"
      },
      {
        id: 8,
        name: "amarra"
      }
    ],
    sectores: [],
    sectoresGroups: [
      { label: "Equipo", path: "equipo.name" },
      { label: "Variedad", path: "variedad.name" }
    ]
  }),
  created() {
    //do something after creating vue instance
    this.temporadaSelected = this.temporadas[1];
    this.lapsoSelected = this.lapsos[0];
    for (var i = 1; i <= 10; i++) {
      this.sectores.push({
        id: i,
        name: "sector " + i,
        equipo: { id: (i % 3) + 1, name: "equipo " + ((i % 4) + 1) },
        variedad: { id: (i % 4) + 1, name: "variedad " + ((i % 4) + 1) }
      });
    }
    for (var i = 1; i < 4; i++) {
      this.add();
    }
    /*
    for (var i = 0; i < 2; i++) {
      var p = _.sample(this.presupuestos)
      if(this.presupuestosGuardados.indexOf(p) == -1){
        this.presupuestosGuardados.push(p);
      }
    }
    */




    /***********/
    var treeData = Anychart.data.tree(this.data, 'as-table');



    /***********/

  },

  mounted() {
  },
  methods: {



    isAttached(presupuesto) {
      return (
        _.find(this.presupuestosGuardados, { id: presupuesto.id }) !== undefined
      );
    },
    attach(presupuesto) {
      if (this.isAttached(presupuesto)) {
        var index = _.findIndex(this.presupuestosGuardados, {
          id: presupuesto.id
        });
        this.presupuestosGuardados.splice(index, 1);
      } else {
        this.presupuestosGuardados.unshift(presupuesto);
      }
    },
    duplicate(presupuesto) {
      var p     = _.cloneDeep(presupuesto);
      var index = _.findIndex(this.presupuestos, { id: presupuesto.id });
      p.id      = _.random(100000, 999999);
      this.presupuestos.splice(index, 0, p);
    },
    load(presupuesto) {
      if(_.findIndex(this.presupuestos, {id: presupuesto.id})){
        var p = _.cloneDeep(presupuesto);
        this.presupuestos.unshift(p);
      }
    },
    quit(presupuesto) {
      var index = _.findIndex(this.presupuestos, { id: presupuesto.id });
      this.presupuestos.splice(index, 1);
    },
    add() {
      this.presupuestos.unshift({
        id: _.random(100000, 999999),

        laborGroup: { name: "Amarra" },
        labores: [],
        unidad: "plantas",

        sectorGroup: { name: "Merlot" },
        sectores: [],

        porcentaje: 33,
        porcentajeEsperado: 50,
        avance: 1000,
        total: 3000
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#principal-container {
  & > header {
    position: sticky;
    top: 0px;
    z-index: 2;
  }
}
.v-input {
  .v-text-field__prefix,
  .v-text-field__suffix {
    color: rgba(0, 0, 0, 0.5);
  }

  &.x-small {
    font-size: 13px;
    margin-bottom: 0px;
    &.v-input--is-focused {
      .v-input__slot {
        background: rgba(255, 255, 255, 0.7) !important;
      }
      fieldset {
        border-width: 1px;
      }
    }
    .v-input__slot {
      min-height: unset;
      background: rgba(255, 255, 255, 0.3);
      height: 24px;
    }
    label {
      top: 4px;
      font-size: 13px;
    }
    .v-input__append-inner {
      margin-top: 7px;
    }
  }

  &.small {
    font-size: 14px;
    margin-bottom: 0px;
    &.v-input--is-focused {
      .v-input__slot {
        background: rgba(255, 255, 255, 0.7) !important;
      }
      fieldset {
        border-width: 1px;
      }
    }
    .v-input__slot {
      min-height: unset;
      background: rgba(255, 255, 255, 0.3);
      height: 35px;
    }
    label {
      top: 8px;
      font-size: 14px;
    }
    .v-input__append-inner {
      margin-top: 7px;
    }
  }
}

.presupuesto {
  .v-card__title {
    height: 40px;
  }
  .v-card__text {
    .card-text-scroll {
      overflow-x: scroll;



    /* Tamaño del scroll */
    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
      padding: 1px;
    }

    /* Estilos barra (thumb) de scroll */
    &::-webkit-scrollbar-thumb {
      background: #78909c;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb:active {
      background-color: #607d8b;
    }

    &::-webkit-scrollbar-thumb:hover {
      background-color: #546e7a;
      box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.2);
    }

    /* Estilos track de scroll */
    &::-webkit-scrollbar-track {
      background: #e1e1e1;
      border-radius: 4px;
      transition: 0.2s all ease;
    }

    &::-webkit-scrollbar-track:hover,
    &::-webkit-scrollbar-track:active {
      background: #d4d4d4;
    }





      .scroll-container {
        width: max-content;
        & > div {
          width: 150px;
          margin-right: -1px;
          vertical-align: top;
          display: inline-block;
        }
      }
    }
  }
}

.list-item {
  display: inline-block;
  margin-right: 10px;
}
.list-enter-active,
.list-leave-active {
  transition: all 1s;
}
.list-enter, .list-leave-to /* .list-leave-active for <2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.v-list-item{
  .v-toolbar{
    z-index:1;
  }
}
.v-list.intercalate{
  .v-list-item:nth-child(odd) {
    background: #fafafa;
  }
}







  .chart {
    width: 100%;
    height: 400px;
  }

  .chart-container {
    text-align: center;
  }


</style>
